var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.dataLoaded && _vm.data.feedbacks.length > 0
    ? _c(
        "div",
        { staticClass: "ts-widget-small" },
        [
          _c("div", { staticClass: "rate" }, [
            _c("div", { staticClass: "a" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "full",
                  style: "width:" + parseFloat(_vm.data.fb_avg) * 20 + "%",
                },
                [
                  _c("i", { staticClass: "fa fa-star" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-star" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-star" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-star" }),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-star" }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "b" }, [
              _vm._v(
                "(" +
                  _vm._s(_vm.data.fb_count_total) +
                  " " +
                  _vm._s(_vm.$attrs.text) +
                  ")"
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("style", { tag: "component" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "blank" }, [
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
      _vm._v(" "),
      _c("i", { staticClass: "fa fa-star" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }